<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>用户管理</el-breadcrumb-item>
      <el-breadcrumb-item>团长信息管理</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">
      <el-form-item label="团长姓名">
        <el-input size="small" v-model="formInline.userName" clearable placeholder="请输入团长姓名"></el-input>
      </el-form-item>
      <el-form-item label="手机号">
        <el-input size="small" v-model="formInline.phoneNumber" clearable placeholder="请输入手机号"></el-input>
      </el-form-item>
      <el-form-item label="身份证号">
        <el-input size="small" v-model="formInline.idNumber" clearable placeholder="请输入身份证号"></el-input>
      </el-form-item>
      <el-form-item label="团长等级">
        <el-select
          size="small"
          clearable
          filterable
          class="full_select"
          v-model="formInline.leaderGrade"
          placeholder="请选择团长等级"
        >
          <el-option
            v-for="item in leaderOptions"
            :key="item.id + '-smlxkey'"
            :label="item.key"
            :value="item.val"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="所属门店">
        <el-select
          size="small"
          clearable
          filterable
          class="full_select"
          v-model="formInline.affiliatedStore"
          placeholder="请选择团长所属门店"

        >
          <el-option
            v-for="item in storeOpts"
            :key="item.id + '-sml'"
            :label="item.value"
            :value="item.key"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="人员归属">
        <el-select
          size="small"
          clearable
          filterable
          class="full_select"
          v-model="formInline.delegationHead"
          placeholder="请选择团长人员归属"

        >
          <el-option
            v-for="item in delegationHeadOpts"
            :key="item.key + '-sml'"
            :label="item.key"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="审核状态">
        <el-select
          size="small"
          clearable
          filterable
          class="full_select"
          v-model="formInline.applyStatus"
          placeholder="请选择审核状态"
        >
          <el-option
            v-for="item in activeOptions"
            :key="item.value + '-smlxkey'"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="状态">
        <el-select
          size="small"
          clearable
          filterable
          class="full_select"
          v-model="formInline.isDelete"
          placeholder="请选择状态"
        >
          <el-option
            v-for="item in isDeleteOptions"
            :key="item.id + '-sml'"
            :label="item.key"
            :value="item.val"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
      </el-form-item>
    </el-form>
    <el-row class="mb20">
      <el-button size="small" type="primary" icon="el-icon-plus" @click="handleAdd()">添加</el-button>
      <el-button size="small" type="success" plain icon="el-icon-download" @click="importLeader">导入</el-button>
      <el-button size="small" type="info" plain icon="el-icon-upload2" @click="handleExport">导出</el-button>
    </el-row>
    <!--列表 姓名，性别，手机号，身份证，钱包余额，开团数量，付款人数，付款金额，付款订单，平均客单价，平均客单佣金，团长等级，资产明细，点击查看每笔交易订单-->
    <el-table size="small" :data="listData" highlight-current-row v-loading="loading" border
              element-loading-text="拼命加载中" style="width: 100%;">
      <el-table-column prop="userName" label="姓名">
      </el-table-column>
      <el-table-column prop="sex" label="性别">
      </el-table-column>
      <el-table-column prop="phone" label="手机号">
      </el-table-column>
      <el-table-column prop="idNumber" label="身份证">
      </el-table-column>
      <el-table-column prop="wallet" label="钱包余额">
      </el-table-column>
      <el-table-column prop="affiliatedStoreCn" label="所属门店">
      </el-table-column>
      <el-table-column prop="delegationHeadCn" label="人员归属">
      </el-table-column>
      <el-table-column prop="payersNumber" label="付款人数">
      </el-table-column>
      <el-table-column prop="payersAmount" label="付款金额">
      </el-table-column>
      <el-table-column prop="payersOrderNumber" label="付款订单">
      </el-table-column>
      <el-table-column prop="averagePrice" label="平均客单价">
      </el-table-column>
      <el-table-column prop="averageCommission" label="平均客单佣金" width="120">
      </el-table-column>
      <el-table-column prop="leaderGrade" label="团长等级">
      </el-table-column>
      <el-table-column prop="leaderSuperior" label="上级团长">
      </el-table-column>
      <el-table-column prop="isResignationCn" label="是否离职">
      </el-table-column>
      <el-table-column prop="createDate" label="添加时间">
        <template slot-scope="scope">
          <div>{{ scope.row.createDate|timestampToTime }}</div>
        </template>
      </el-table-column>
      <el-table-column prop="updateDate" label="审核时间">
        <template slot-scope="scope">
          <div>{{ scope.row.updateDate|timestampToTime }}</div>
        </template>
      </el-table-column>
      <el-table-column prop="applyStatus" label="审核状态">
        <template slot-scope="scope">
          <!-- 0-待审核 1-已同意 2-已拒绝  -->
          <el-tag :type="activeType[scope.row.applyStatus*1]">{{ activeText[scope.row.applyStatus * 1] }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column align="center" label="审核" width="150"  fixed="right">
        <template slot-scope="scope">
          <el-button-group>
            <el-button type="success" plain :disabled="scope.row.applyStatus!=='0'" size="mini"
                       @click="applyHandler('1',scope.row)">同意
            </el-button>
            <el-button type="danger" plain :disabled="scope.row.applyStatus!=='0'" size="mini"
                       @click="applyHandler('2',scope.row)">拒绝
            </el-button>
          </el-button-group>
        </template>

      </el-table-column>
      <el-table-column align="center" label="操作" width="220"  fixed="right">
        <template slot-scope="scope">
          <div class="flex-view">
            <div class="btn-area">
              <el-button size="mini" type="primary" plain :disabled="scope.row.applyStatus!='1'"
                         @click="handleEdit(scope.$index, scope.row)">资产明细
              </el-button>
            </div>
            <div class="btn-area">
              <el-button size="mini" type="primary" plain :disabled="scope.row.applyStatus!='1'"
                         @click="handleLeaderList(scope.$index, scope.row)">团员明细
              </el-button>
            </div>
            <div class="btn-area">
              <el-button :type="'success'" :disabled="scope.row.isResignation =='1'"
                         size="mini" @click="leaveHandler(scope.row)">
                离职
              </el-button>
            </div>
            <div class="btn-area">
              <el-button :type="scope.row.isDelete=='0'?'danger':'success'" :disabled="scope.row.applyStatus!='1'"
                         size="mini" @click="delHandler(scope.row)">
                {{ scope.row.isDelete == '0' ? '禁用' : '启用' }}
              </el-button>
            </div>
            <div class="btn-area">
              <el-button :type="'danger'" :disabled="scope.row.isResignation =='1'"
                         size="mini" @click="editHandler(scope.row)">
                修改
              </el-button>
            </div>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    <!-- 资产明细 -->
    <el-drawer title="交易记录" :visible.sync="assetListVisible" size="50%" @close="closeDialog">
      <div class="prople_info">
        <el-table
          :data="peopleData"
          height="90%"
          border
          style="width: 100%">
          <el-table-column
            prop="outTradeNo"
            label="订单号"
            width="280">
          </el-table-column>
          <el-table-column
            prop="userNmae"
            label="购买人"
            width="180">
          </el-table-column>
          <el-table-column
            prop="commission"
            label="佣金">
          </el-table-column>
          <el-table-column
            prop="createDate"
            label="时间">
          </el-table-column>
        </el-table>
        <Pagination v-bind:child-msg="pageparmZ" @callFather="callFatherZ"></Pagination>
      </div>
    </el-drawer>
    <!--      团员明细-->
    <el-drawer title="团员明细" :visible.sync="leaderListVisible" size="50%" @close="closeDialog">
      <div class="prople_info">
        <el-table
          :data="leaderListData"
          height="90%"
          border
          style="width: 100%">
          <el-table-column
            prop="userName"
            label="用户名"
            width="280">
          </el-table-column>
          <el-table-column
            prop="phone"
            label="手机号码"
            width="180">
          </el-table-column>
          <el-table-column
            prop="leaderGrade"
            label="团长等级">
          </el-table-column>
        </el-table>
        <Pagination v-bind:child-msg="pageparmT" @callFather="callFatherT"></Pagination>
      </div>
    </el-drawer>
    <!-- 添加界面 -->
    <el-dialog :title="title" :visible.sync="addFormVisible" width="30%" @close="closeDialog('editForm')">
      <el-form label-width="120px" :model="editForm" ref="editForm" :rules="rules">
        <!-- <el-form-item label="选择团长" prop="nationalOss">
            <el-select
              size="small"
              clearable
              filterable
              class="full_select"
              v-model="formInline.source"
              placeholder="请选择用户成为团长"
            >
              <el-option
                v-for="item in 3"
                :key="item + '-smlxkey'"
                :label="item"
                :value="item"
              >
              </el-option>
            </el-select>
        </el-form-item> -->
        <el-form-item label="团长姓名" prop="userName">
          <el-input placeholder="请输入团长姓名" v-model="editForm.userName" size="small"></el-input>
        </el-form-item>
        <el-form-item label="团长身份证号" prop="idNumber">
          <el-input placeholder="请输入团长身份证号" v-model="editForm.idNumber" size="small"></el-input>
        </el-form-item>
        <el-form-item label="团长手机号" prop="phoneNumber">
          <el-input placeholder="请输入团长手机号" v-model="editForm.phoneNumber" size="small"></el-input>
        </el-form-item>
        <el-form-item label="团长等级" prop="leaderGrade">
          <el-select
            size="small"
            clearable
            filterable
            class="full_select"
            v-model="editForm.leaderGrade"
            placeholder="请选择团长等级"
          >
            <el-option
              v-for="item in 3"
              :key="item + '-smlxkey'"
              :label="item"
              :value="item"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="人员归属" prop="delegationHead" >
          <el-select
            size="small"
            clearable
            filterable
            class="full_select"
            v-model="editForm.delegationHead"
            placeholder="请选择人员归属"
            :disabled="!editForm.leaderGrade"
          >
            <el-option
              v-for="item in delegationHeadOpts"
              :key="item.key + '-sml'"
              :label="item.key"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="上级团长" prop="invitationUserId" v-show="editForm.leaderGrade == 2 || editForm.leaderGrade == 3">
          <el-select
            size="small"
            clearable
            filterable
            class="full_select"
            v-model="editForm.invitationUserId"
            placeholder="请选择上级团长"
          >
            <el-option
              v-for="item in upLeaderData"
              :key="item.userId + '-sjtzkey'"
              :label="item.userName"
              :value="item.userId"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="所属门店"  prop="affiliatedStore"  v-show="editForm.leaderGrade !==1  && editForm.delegationHead === '0'">
          <el-select
            size="small"
            clearable
            filterable
            class="full_select"
            v-model="editForm.affiliatedStore"
            placeholder="请选择团长所属门店"

          >
            <el-option
              v-for="item in storeOpts"
              :key="item.id + '-sml'"
              :label="item.value"
              :value="item.key"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeDialog('editForm')">取消</el-button>
        <el-button size="small" type="primary" :loading="loading" class="title" @click="submitForm('editForm')">保存
        </el-button>
      </div>
    </el-dialog>
<!--    编辑界面-->
    <el-dialog :title="title" :visible.sync="editFormVisible" width="30%" @close="closeDialog('editFormData')">
      <el-form label-width="120px" :model="editFormData" ref="editFormData" :rules="editrules">
        <!-- <el-form-item label="选择团长" prop="nationalOss">
            <el-select
              size="small"
              clearable
              filterable
              class="full_select"
              v-model="formInline.source"
              placeholder="请选择用户成为团长"
            >
              <el-option
                v-for="item in 3"
                :key="item + '-smlxkey'"
                :label="item"
                :value="item"
              >
              </el-option>
            </el-select>
        </el-form-item> -->
        <el-form-item label="团长姓名" prop="userName">
          <el-input placeholder="请输入团长姓名" v-model="editFormData.userName" size="small" disabled></el-input>
        </el-form-item>
        <el-form-item label="团长身份证号" prop="idNumber">
          <el-input placeholder="请输入团长身份证号" v-model="editFormData.idNumber" size="small" disabled></el-input>
        </el-form-item>
        <el-form-item label="团长手机号" prop="phoneNumber">
          <el-input placeholder="请输入团长手机号" v-model="editFormData.phone" size="small" disabled></el-input>
        </el-form-item>
        <el-form-item label="团长等级" prop="leaderGrade" >
          <el-select
            size="small"
            clearable
            filterable
            class="full_select"
            v-model="editFormData.leaderGrade"
            placeholder="请选择团长等级"
          >
            <el-option
              v-for="item in leaderGradeOpts"
              :key="item + '-sm'"
              :label="item"
              :value="item"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="人员归属" prop="delegationHead" >
          <el-select
            size="small"
            clearable
            filterable
            class="full_select"
            v-model="editFormData.delegationHead"
            placeholder="请选择人员归属"

          >
            <el-option
              v-for="item in delegationHeadOpts"
              :key="item.key + '-sml'"
              :label="item.key"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="所属门店" prop="affiliatedStore" v-show="editFormData.delegationHead === '0' && editFormData.leaderGrade !== 1" >
          <el-select
            size="small"
            clearable
            filterable
            class="full_select"
            v-model="editFormData.affiliatedStore"
            placeholder="请选择团长所属门店"

          >
            <el-option
              v-for="item in storeOpts"
              :key="item.id + '-sml'"
              :label="item.value"
              :value="item.key"
            >
            </el-option>
          </el-select>
        </el-form-item>

<!--        <el-form-item label="上级团长" prop="invitationUserId" v-if="editFormData.leaderGrade == 2 || editFormData.leaderGrade == 3">-->
<!--          <el-select-->
<!--            size="small"-->
<!--            clearable-->
<!--            filterable-->
<!--            class="full_select"-->
<!--            v-model="editFormData.invitationUserId"-->
<!--            placeholder="请选择上级团长"-->
<!--          >-->
<!--            <el-option-->
<!--              v-for="item in upLeaderData"-->
<!--              :key="item.userId + '-sjtzkey'"-->
<!--              :label="item.userName"-->
<!--              :value="item.userId"-->
<!--            >-->
<!--            </el-option>-->
<!--          </el-select>-->
<!--        </el-form-item>-->
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeDialog('editFormData')">取消</el-button>
        <el-button size="small" type="primary" :loading="loading" class="title" @click="editSubmit('editFormData')">保存
        </el-button>
      </div>
    </el-dialog>
    <!-- 导入对话框 -->
    <el-dialog :title="upload.title" :visible.sync="upload.open" width="400px" append-to-body>
      <el-upload
        ref="upload"
        :limit="1"
        accept=".xlsx, .xls"
        :headers="upload.headers"
        :action="upload.url + '?updateSupport=' + upload.updateSupport"
        :disabled="upload.isUploading"
        :on-progress="handleFileUploadProgress"
        :on-success="handleFileSuccess"
        :auto-upload="false"
        drag
      >
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
        <div class="el-upload__tip text-center" slot="tip">
          <div class="el-upload__tip" slot="tip">
            <el-checkbox v-model="upload.updateSupport"/>
            是否更新已经存在的数据
          </div>
          <span>仅允许导入xls、xlsx格式文件。</span>
          <el-link type="primary" :underline="false" style="font-size:12px;vertical-align: baseline;"
                   @click="importTemplate">下载模板
          </el-link>
        </div>
      </el-upload>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitFileForm">确 定</el-button>
        <el-button @click="upload.open = false">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  leaderList,
  recordsList,
  addLeader,
  apply,
  getTemlate,
  importLeader,
  exportLeader,
  disableLeader,
  listMember,
  selectUpLeader
} from '@/api/system'
import {leaveLeader, leaderById, getStore, leaderChange} from "@/api/leader"
import exportFile from '@/utils/exportFile'
import {Loading} from 'element-ui'
import Pagination from '../../components/Pagination'

export default {
  data() {
    return {
      nshow: true, //switch开启
      fshow: false, //switch关闭
      loading: false, //是显示加载
      editFormVisible: false, //控制编辑页面显示与隐藏
      addFormVisible: false,//控制新增页面显示与隐藏
      assetListVisible:false,//控制资产明细页面显示与隐藏
      leaderListVisible: false,//团员明细控制
      title: '添加',
      activeText: ['待审核', '已同意', '已拒绝'],
      activeType: ['info', 'success', 'danger'],
      activeOptions: [
        {label: '待审核', value: '0'}, {label: '已同意', value: '1'}, {label: '已拒绝', value: '2'}
      ],
      leaderOptions:[
        {
          id:1,
          key:'1级团长',
          val:1
        },
        {
          id:2,
          key:'2级团长',
          val:2
        },
        {
          id:3,
          key:'3级团长',
          val:3
        },
      ],
      isDeleteOptions:[
        {
          id:1,
          key:'启用',
          val:0
        },
        {
          id:2,
          key:'禁用',
          val:1
        },
      ],
      delegationHeadOpts:[{
        key:'国药',
        value:"0"}, {key:'普通',
        value:"1"}],
      editForm: {
        leaderGrade: null,
        invitationUserId:null
      },
      editFormData :{

      },
      peopleData: [],
      leaderListData: [],
      // upLeaderData: [],//上级团长数据
      leader1Data: [],//1级
      leader2Data: [],//2级
      upload: {
        // 是否显示弹出层（导入）
        open: false,
        // 弹出层标题（导入）
        title: "",
        // 是否禁用上传
        isUploading: false,
        // 是否更新已经存在的用户数据
        updateSupport: false,
        // 设置上传的请求头部
        headers: {Authorization: localStorage.getItem('logintoken')},
        // 上传的地址
        url: process.env.VUE_APP_BASE_API + "/leader/importData"
      },
      // rules表单验证
      rules: {
        leaderGrade: [
          {required: true, message: '请选择团长等级', trigger: 'change'}
        ],
        invitationUserId: [
        ],
        affiliatedStore:[],
        delegationHead:[
          {required: true, message: '请选择人员归属', trigger: 'change'}
        ],
        userName: [
          {required: true, message: '请输入团长姓名', trigger: 'blur'}
        ],
        idNumber: [
          {required: true, message: "身份证号不能为空", trigger: "blur"},
          {
            pattern: /^([1-6][1-9]|50)\d{4}(18|19|20)\d{2}((0[1-9])|10|11|12)(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/,
            message: "请输入正确的身份证号",
            trigger: "blur"
          }
        ],
        phoneNumber: [
          {required: true, message: "手机号码不能为空", trigger: "blur"},
          {
            pattern: /^1[3|4|5|6|7|8|9][0-9]\d{8}$/,
            message: "请输入正确的手机号码",
            trigger: "blur"
          }
        ],

      },
      editrules:{
        leaderGrade: [
          {required: true, message: '请选择团长等级', trigger: 'change'}
        ],
        delegationHead: [
          {required: true, message: '请选择人员归属', trigger: 'change'}
        ],
        affiliatedStore:[]
      },
      formInline: {
        page: 1,
        limit: 10,
        userName:null,
        phoneNumber:null,
        idNumber:null,
        leaderGrade:null,
        applyStatus:null,
        isDelete:null,
      },
      // 删除部门
      seletedata: {
        ids: '',
        token: localStorage.getItem('logintoken')
      },
      userparm: [], //搜索权限
      listData: [], //用户数据
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      },
      queryFormZ:{
        page: 1,
        limit: 10,
        userId:null
      },
      //资产明细分页
      pageparmZ: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      },
      queryFormT:{
        page: 1,
        limit: 10,
        userId:null
      },
      //团员明细分页
      pageparmT: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      },
      storeOpts:[],
      leaderGradeOpts:[2,3]
    }
  },
  computed: {
    leaderSuperiorRequired() {
      return (this.editForm.leaderGrade == 2 || this.editForm.leaderGrade == 3) ? true : false
    },
    upLeaderData() {
      return this.editForm.leaderGrade == 2 ? this.leader1Data:this.leader2Data
    },
    editFormLeaderGrade() {
      return this.editForm.leaderGrade;
    },
    editFormDelegationHead() {
      return this.editForm.delegationHead;
    },
    editFormDDelegationHead() {
      return this.editFormData.delegationHead;
    },
  },
  watch: {
    editFormLeaderGrade(newVal, oldVal){
      if ((newVal == 2 || newVal == 3) && this.editForm.delegationHead === "0"){
        console.log(1111222)
        const affiliatedStore =[
          {required: true, message: '请选择团长所属门店', trigger: 'change'}
        ]
        const invitationUserId =[
          {required: true, message: '请选择上级团长', trigger: 'change'}
        ]
        this.rules = { ...this.rules, invitationUserId,affiliatedStore };
      }
      else if (newVal == 2 || newVal == 3) {
        const invitationUserId =[
          {required: true, message: '请选择上级团长', trigger: 'change'}
        ]
        this.rules = { ...this.rules, invitationUserId };

      }
      else if(newVal == 1) {
        // 清除指定校验规则
        this.$refs["editForm"].clearValidate(["invitationUserId","affiliatedStore"]);
        // 这行必须
        this.rules = { ...this.rules, invitationUserId: [], affiliatedStore: [] };
        this.editForm.invitationUserId = null;
        this.editForm.affiliatedStore = null
      }
      else {
        // 清除指定校验规则
        this.$refs["editForm"].clearValidate(["invitationUserId"]);
        // 这行必须
        this.rules = { ...this.rules, invitationUserId: [] };
        this.editForm.invitationUserId = null
      }
    },
    editFormDelegationHead(newVal, oldVal) {
      console.log(this.editForm.leaderGrade)
      if (newVal ==="0" && this.editForm.leaderGrade != 1) {
        console.log(111)
        const affiliatedStore =[
          {required: true, message: '请选择团长所属门店', trigger: 'change'}
        ]
        this.rules = { ...this.rules, affiliatedStore };
        console.log(this.rules)
      }
      else {
        console.log(222)
        // 清除指定校验规则
        this.$refs["editForm"].clearValidate(["affiliatedStore"]);
        // 这行必须
        this.rules = { ...this.rules, affiliatedStore: [] };
        this.editForm.affiliatedStore = null
      }
    },
    editFormDDelegationHead(newVal, oldVal) {
      console.log(this.editFormData.leaderGrade)
      if (newVal ==="0"  && this.editFormData.leaderGrade !== 1) {
        const affiliatedStore =[
          {required: true, message: '请选择团长所属门店', trigger: 'change'}
        ]
        this.editrules = { ...this.editrules, affiliatedStore };
        console.log(this.editrules)
      }
      else {
        // 清除指定校验规则
        this.$refs["editFormData"].clearValidate(["affiliatedStore"]);
        // 这行必须
        this.editrules = { ...this.editrules, affiliatedStore: [] };
        this.editFormData.affiliatedStore = null
      }
    }
  },
  // 注册组件
  components: {
    Pagination
  },
  created() {
    this.getdata(this.formInline)
    this.getUpLeaderData()
    this.getStoreList()
  },

  methods: {
    // 获取团长列表
    getdata(parameter) {
      this.loading = true
      leaderList(parameter).then(res => {
        this.loading = false
        if (res.code != 200) {
          this.$message({
            type: 'info',
            message: res.msg
          })
        } else {
          this.listData = res.rows
          console.log(res, this.listData);
          // 分页赋值
          this.pageparm.currentPage = this.formInline.page
          this.pageparm.pageSize = this.formInline.limit
          this.pageparm.total = res.total
        }
      })
        .catch(err => {
          this.loading = false
          this.$message.error('加载失败，请稍后再试！')
        })
    },
    getUpLeaderData() {
      selectUpLeader({leaderGrade:1}).then(res => {
        if (res.rsp_code != 200) {
          this.$message({
            type: 'info',
            message: res.msg
          })
        } else {
          this.leader1Data = res.body
        }
      })
        .catch(err => {
          this.$message.error('加载失败，请稍后再试！')
        })
      selectUpLeader({leaderGrade:2}).then(res => {
        if (res.rsp_code != 200) {
          this.$message({
            type: 'info',
            message: res.msg
          })
        } else {
          this.leader2Data = res.body
        }
      })
        .catch(err => {
          this.$message.error('加载失败，请稍后再试！')
        })
    },
    //获取门店列表
    getStoreList() {
      this.loading = true
      getStore().then(res => {
        this.loading = false

          this.storeOpts = res.body
          console.log(this.storeOpts)

      })
        .catch(err => {
          this.loading = false
          this.$message.error('加载失败，请稍后再试！')
        })
    },
    // 分页插件事件
    callFather(parm) {
      this.formInline.page = parm.currentPage
      this.formInline.limit = parm.pageSize
      this.getdata(this.formInline)
    },
    // 资产明细分页插件事件
    callFatherZ(parm) {
      this.queryFormZ.page = parm.currentPage
      this.queryFormZ.limit = parm.pageSize
      this.getRecordsList()
    },
    // 团员明细分页插件事件
    callFatherT(parm) {
      this.queryFormT.page = parm.currentPage
      this.queryFormT.limit = parm.pageSize
      this.getListMember()
    },
    // 搜索事件
    search() {
      this.formInline.page = 1
      this.getdata(this.formInline)
    },
    //显示资产明细页面
    handleEdit: function (index, row) {
      this.assetListVisible = true;
      this.queryFormZ.userId = row.userId
      this.getRecordsList()

    },
    getRecordsList() {
      recordsList(this.queryFormZ).then(res => {
        this.peopleData = res.rows;
        this.pageparmZ.total = res.total
      })
    },
    //显示团员明细界面
    handleLeaderList: function (index, row) {
      this.leaderListVisible = true
      this.queryFormT.userId = row.userId
      this.getListMember()
    },
    getListMember() {
      listMember(this.queryFormT).then(res => {
        this.leaderListData = res.rows
        this.pageparmT.total = res.total
      })
    },
    handleAdd() {
      this.editForm = {
        leaderGrade: null,
        invitationUserId:null
      }
      this.addFormVisible = true
      this.title = '添加'
      console.log(this.editForm.leaderGrade)
    },
    // 编辑、增加页面保存方法
    submitForm(editData) {
      this.$refs[editData].validate(valid => {
        if (valid) {
          addLeader(this.editForm).then(res => {

            this.addFormVisible = false
            this.loading = false
            if (res.rsp_code == 200) {
              this.getdata(this.formInline)
              this.$message({
                type: 'success',
                message: res.rsp_msg
              })

              this.addFormVisible = false
            } else {
              this.$message({
                type: 'info',
                message: res.rsp_msg
              })

              this.addFormVisible = false
            }
          })
            .catch(err => {

              this.addFormVisible = false
              this.loading = false
              this.$message.error(res.rsp_msg)
            })
        } else {
          return false
        }
      })
    },
    applyHandler(status, row) {
      let text = status == '1' ? '同意' : '拒绝'
      let params = {
        applyStatus: status,
        id: row.id
      }
      this.$confirm('确定要' + text + '吗?', '信息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        apply(params).then(res => {
          if (res.rsp_code == 200) {
            this.getdata(this.formInline)
            this.$message({
              type: 'success',
              message: res.rsp_msg
            })
          } else {
            this.$message({
              type: 'info',
              message: res.rsp_msg
            })
          }
        })
      })
    },
    delHandler(row) {
      let text = row.isDelete == '0' ? '禁用' : '启用'
      this.$confirm('确定要' + text + row.userName + '团长吗?', '信息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let par = {
          id: row.id,
          isDelete: row.isDelete == '0' ? '1' : '0'
        }
        disableLeader(par).then(res => {
          this.$message.success(text + '成功！')
          this.getdata(this.formInline)
        })
      })
    },
    //离职操作
    leaveHandler(row) {
      this.$confirm(   row.userName  +'团长确定要离职吗?', '信息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let par = {
          userId: row.userId
        }
        leaveLeader(par).then(res => {
          if(res.rsp_code == 200) {
            this.$message.success('离职成功！')
            this.getdata(this.formInline)
          }
          else {
            this.$message.success(res.rsp_msg)
          }
        })
      })
    },
    editHandler(row) {
      this.reset();
      const _id = row.id
      let that = this;
      this.editFormData = {...row}
      that.editFormVisible = true
        that.title = '修改'
      // leaderById(_id).then(response => {
      //   this.editFormData = response.data;
      //
      //   that.editFormVisible = true
      //   that.title = '修改'
      // });

    },
    editSubmit(editData) {
      this.$refs[editData].validate(valid => {
        if (valid) {
          leaderChange(this[editData]).then(res => {

            this.editFormVisible = false
            this.loading = false
            if (res.rsp_code == 200) {
              this.getdata(this.formInline)
              this.$message({
                type: 'success',
                message: res.rsp_msg
              })


            } else {
              this.$message({
                type: 'info',
                message: res.rsp_msg
              })


            }
          })
            .catch(err => {

              this.editFormVisible = false
              this.loading = false
              this.$message.error(res.rsp_msg)
            })
        } else {
          return false
        }
      })
    },
    /** 导入按钮操作 */
    importLeader() {
      this.upload.title = "团长导入";
      this.upload.open = true;
    },
    /** 导出按钮操作 */
    handleExport() {
      // this.download('system/goods/export', {
      //   ...this.queryParams
      // }, `goods_${new Date().getTime()}.xlsx`)
      let downloadLoadingInstance;
      downloadLoadingInstance = Loading.service({
        text: "正在下载数据，请稍候",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      })
      exportLeader().then(res => {
        exportFile.getExcel(res, `leaderList_${new Date().getTime()}`)
        downloadLoadingInstance.close()
      }).catch(() => {
        downloadLoadingInstance.close()
      })
    },
    // 下载模板
    importTemplate() {
      let downloadLoadingInstance;
      downloadLoadingInstance = Loading.service({
        text: "正在下载数据，请稍候",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      })
      getTemlate().then(res => {
        exportFile.getExcel(res, `leaderTemplate_${new Date().getTime()}`)
        downloadLoadingInstance.close()
      }).catch(() => {
        downloadLoadingInstance.close()
      })
    },
    // 文件上传中处理
    handleFileUploadProgress(event, file, fileList) {
      this.upload.isUploading = true;
    },
    // 文件上传成功处理
    handleFileSuccess(response, file, fileList) {
      this.upload.open = false;
      this.upload.isUploading = false;
      this.$refs.upload.clearFiles();
      this.$alert("<div style='overflow: auto;overflow-x: hidden;max-height: 70vh;padding: 10px 20px 0;'>" + response.rsp_msg + "</div>", "导入结果", {dangerouslyUseHTMLString: true});
      this.getdata(this.formInline)
    },
    // 提交上传文件
    submitFileForm() {
      this.$refs.upload.submit();
    },
    // 关闭编辑、增加弹出框
    closeDialog(form) {
      this.editFormVisible = false,
        this.addFormVisible = false,
        this.leaderListVisible = false;
      this.assetListVisible = false;
      if (form) {
        this.$refs[form].resetFields()
      }

    },
    reset(){
      this.editFormData = {

      }
    }
  }
}
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}

.userRole {
  width: 100%;
}

.prople_info {
  height: 100%;
  padding: 30px;
}

.flex-view {
  display: flex;
  flex-wrap: wrap
}

.justify {
  justify-content: center;
}

.align {
  align-items: center;
}

.btn-area {
  padding: 0 10px 10px 0;
}
</style>




// WEBPACK FOOTER //
// src/views/system/groupManage.vue